// @flow

import type {ApplicationState} from "../reducers";
import {vehicleReset, vehicleSet} from "../reducers/filterReducer";
import {descendThroughSingleChildren} from "../helper/vehicleKey";

export const setVehicle = (vehicleSeries: string = null, vehicleModel: string = null, selectionSource: string = "filter_top") => {
    return (dispatch, getState: () => ApplicationState) => {
        const state = getState();
        const filterStatsSeries = state.filter.filterStats.vehicleSeries || [];
        const brandSeries = (state.content.brand && state.content.brand.vehicleSeries) || [];
        const selectionValues = [vehicleSeries, vehicleModel].filter(Boolean);
        const matchesSelection = (entry, value) =>
            value && (entry.title === value || entry.key === value || entry.name === value);
        const matchesAnySelection = entry => selectionValues.some(value => matchesSelection(entry, value));
        const findInCategories = (categories, value) => {
            for (let category of categories || []) {
                if (matchesSelection(category, value)) {
                    return category;
                }
                const nestedMatch = findInCategories(category.categories || [], value);
                if (nestedMatch) {
                    return nestedMatch;
                }
            }
            return null;
        };
        const findCategory = (allSeries, value) => {
            for (let series of allSeries) {
                const match = findInCategories(series.categories || [], value);
                if (match) {
                    return match;
                }
            }
            return null;
        };
        const resolveSelection = allSeries => ({
            selectedSeries: allSeries.find(series => matchesAnySelection(series)) || null,
            selectedModel: selectionValues.reduce((match, value) => match || findCategory(allSeries, value), null),
        });
        // filterStats only holds vehicles fitted by the products of the current view, while
        // the bar offers every vehicle of the configure snapshot (brand). Fall back to the
        // brand catalog so picking a vehicle without own products in this view still sets
        // the filter instead of silently dropping it.
        const fromFilterStats = resolveSelection(filterStatsSeries);
        const {selectedSeries, selectedModel} = fromFilterStats.selectedModel || fromFilterStats.selectedSeries
            ? fromFilterStats
            : resolveSelection(brandSeries);
        // If the picked node has only one child (and that child only one child, etc.) the
        // deeper levels carry no additional choice; descend automatically so the most
        // specific vehicleKey is used as the filter.
        const pickedNode = selectedModel || selectedSeries;
        const deepestNode = pickedNode ? descendThroughSingleChildren(pickedNode) : null;
        dispatch(vehicleSet({
            vehicle: selectedSeries,
            vehicleModel: deepestNode && deepestNode !== selectedSeries ? deepestNode : selectedModel,
            vehicleKey: deepestNode ? deepestNode.key : null,
            selectionSource,
        }));
    };
};

export function resetVehicle() {
    return vehicleReset();
}
